import { useCallback, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { getDmcTree } from '../../services/treeService'
import useNotifications from '../../hooks/useNotifications'
import usePersonCount from './usePersonCount'
import useTreeGroups from './useTreeGroups'

export default function useTree(treeId) {
  const { t } = useTranslation()
  const { error } = useNotifications()
  const [tree, setTree] = useState()
  const [originalTree, setOriginalTree] = useState()
  const { fetchPersonCount } = usePersonCount(treeId, setTree)
  const { fetchTreeGroups } = useTreeGroups(treeId, setTree)

  const fetchTree = async () => {
    await getDmcTree(treeId)
      .then((treeResponse) => {
        setTree((prevState) => {
          return {
            ...Object.fromEntries(Object.entries(treeResponse.data.tree).filter(([key]) => key !== 'devkeys')),
            agentApps: treeResponse.data.agentApps?.join(', '),
            vendorCorporation: treeResponse.data.vendorCorporation,
            ...prevState,
          }
        })
      })
      .catch((err) => {
        if (err.response && err.response.status === 410) {
          // it returns HTTP 410 if the tree is tombstoned
          setTree((prevState) => {
            return { ...err.response.data, ...prevState }
          })
          //  setOriginalTree(err.response.data)
        } else {
          error(`${t('tree.error.tree', 'Error getting tree')} ${treeId}: ${err.message || ''}`, err)
        }
      })
  }

  const loadTree = useCallback(async () => {
    if (treeId) {
      setTree()
      setOriginalTree()
      Promise.all([await fetchTree(), await fetchPersonCount(), await fetchTreeGroups()]).finally(() => {
        setTree((prevState) => {
          setOriginalTree(prevState)
          return prevState
        })
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [treeId])

  useEffect(() => {
    loadTree()
  }, [loadTree])

  const state = { tree, originalTree }
  const actions = { setTree, setOriginalTree, loadTree }

  return { state, actions }
}
